import React, { useEffect, useRef, useState } from "react";

export function PlaceholderToken({ placeholder, parts, partIndex, fieldPath, onFill }) {
  const [editing, setEditing] = useState(false);
  const [value, setValue] = useState(placeholder.slice(1, -1));
  const inputRef = useRef();

  useEffect(() => {
    if (editing) {
      inputRef.current?.focus();
      inputRef.current?.select();
    }
  }, [editing]);

  const commit = () => {
    const trimmed = value.trim();
    if (trimmed) {
      const newParts = [...parts];
      newParts[partIndex] = trimmed;
      onFill(fieldPath, newParts.join(""));
    }
    setEditing(false);
  };

  if (editing) {
    return (
      <input
        ref={inputRef}
        value={value}
        onChange={e => setValue(e.target.value)}
        onBlur={commit}
        onKeyDown={e => {
          if (e.key === "Enter") { e.preventDefault(); commit(); }
          if (e.key === "Escape") setEditing(false);
        }}
        onClick={e => e.stopPropagation()}
        style={{
          display: "inline",
          fontSize: "inherit",
          fontFamily: "inherit",
          lineHeight: "inherit",
          minWidth: "3em",
          width: `${Math.max(value.length + 2, 5)}ch`,
        }}
        className="bg-amber-50 border border-amber-400 text-amber-900 rounded px-1 outline-none"
      />
    );
  }

  return (
    <span
      onClick={e => { e.stopPropagation(); setEditing(true); }}
      title="Click to fill in this value"
      className="bg-amber-100 text-amber-700 border border-dashed border-amber-400 rounded px-0.5 cursor-pointer hover:bg-amber-200 transition-colors select-none"
    >
      {placeholder}
    </span>
  );
}

export function renderTextWithPlaceholders(text, path, editable, onFill) {
  if (!text || typeof text !== "string") return text || "";
  const parts = text.split(/(\[[^\]]+\])/);
  if (parts.length === 1) return text;
  return parts.map((part, i) => {
    if (/^\[[^\]]+\]$/.test(part)) {
      return editable ? (
        <PlaceholderToken
          key={`${path}-${i}`}
          placeholder={part}
          parts={parts}
          partIndex={i}
          fieldPath={path}
          onFill={onFill}
        />
      ) : (
        <span key={i} className="bg-amber-100 text-amber-700 rounded px-0.5">{part}</span>
      );
    }
    return part;
  });
}
